import isClient from 'commons/isClient';
import { logError } from './logger';

function encodeBase64(str) {
  try {
    let encodedStr = '';

    if (isClient()) {
      encodedStr = window.btoa(str);
    } else {
      const buffer =
        str instanceof Buffer ? str : Buffer.from(str.toString(), 'binary');
      encodedStr = buffer.toString('base64');
    }

    return encodedStr.replace(/[+/]/gi, x => {
      if (x === '+') return '-';
      if (x === '/') return '_';
      return x;
    });
  } catch (e) {
    logError(e);
    return '';
  }
}

export default encodeBase64;
